import React, { useRef } from 'react'
import ContentTitle from './content-title'
import ContentLeft from './content-left'
import ContentRight from './content-right'
import axiosRc from '../../../config/axios-rc'
import { getUserStorage, setJobReqStorage } from '../../../utils/localStorage'
import { decryptData } from '../../../utils/cryptoJs'
import { useSetRecoilState } from 'recoil'
import { isLoadingState, toggleLoginPopUpState } from '../../../recoil/states/default'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ModalRc } from '../../../components/modalRc'
import { attachmentList } from '../../applicantProfile/constant'
import ReactGA from 'react-ga4';

const Content = (props) => {
    const { job } = props
    const setToggleLoginPopup = useSetRecoilState(toggleLoginPopUpState)
    const setIsLoading = useSetRecoilState(isLoadingState)
    const history = useNavigate()
    const clicks = useRef(0);

    const handleClickApply = async () => {
        try {
            if (clicks.current === 0) {
                clicks.current = 1;
                setIsLoading(true)
                const user = getUserStorage()
                let isOtp = false
                if (user && user.checkLogin) {
                    const decryptedData = decryptData(user.checkLogin)
                    if (decryptedData) {
                        isOtp = decryptedData.isOtp //&& new Date().getTime() <= decryptedData.expiry
                    }
                }

                if (isOtp) {
                    // ถ้า Login แล้วยังไม่ได้กรอกใบสมัคร ให้เด้งไปหน้าใบสมัครของฉัน
                    if (!user.id) {
                        history('/applicantProfile', { state: { jobReq: job } })
                        return false
                    }

                    if (!checkStartDateApply()) {
                        const propsModal = {
                            type: 'error',
                            classModal: 'error',
                            content: 'ไม่สามารถสมัครได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร',
                            okText: "ปิด",
                            onOk: () => { },
                        }
                        ModalRc(propsModal)
                        return false
                    }

                    const _query = `?email=${user?.email}&jobReqDocumentNo=${job?.documentNo}`
                    // เช็คว่าสมัครตำแหน่งนี้ไปแล้วหรือยัง
                    const checkApplied = await axiosRc.get(`candidate/check_duplicate_jobRequestNo${_query}`);
                    if (checkApplied && checkApplied.data?.jobReqDocumentNo) {
                        // alert duplicate
                        const propsModal = {
                            type: 'error',
                            classModal: 'error',
                            content: 'คุณได้สมัครตำแหน่งนี้แล้ว',
                            okText: "ปิด",
                            onOk: () => { },
                        }
                        ModalRc(propsModal)
                    } else {
                        // check ข้อมูลครบถ้วนหรือไม่
                        const validData = await checkInvalidData(user)
                        if (!validData) {
                            const propsModal = {
                                type: 'confirm',
                                classModal: 'error',
                                content: 'ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจากกรอกข้อมูลไม่ครบ',
                                okText: "เพิ่มข้อมูล",
                                onOk: async () => {
                                    history('/applicantProfile', { state: { jobReq: job } })
                                },
                                onCancel: () => { },
                            }
                            ModalRc(propsModal)
                            return false
                        }

                        if (await checkAttachFile(user) && await checkCarLicense(user)) {
                            const propsModal = {
                                type: 'confirm',
                                classModal: 'info',
                                title: `ยืนยันการสมัครตำแหน่ง`,
                                content: `${job?.positionCareerName ?? ''} ${job?.orgUnitName ?? ''}`,
                                okText: "ยืนยัน",
                                onOk: () => {
                                    applyJob(user)
                                },
                                onCancel: () => { },
                            }
                            ModalRc(propsModal)
                        }
                    }
                } else {
                    setJobReqStorage(job)
                    setToggleLoginPopup(true)
                }
                setTimeout(() => {
                    clicks.current = 0;
                }, 500);
            }
        }
        catch (e) {
            console.log('สมัครไม่สำเร็จ ===>', e)
            message.error('สมัครไม่สำเร็จ, กรุณาติดต่อผู้ดูแลระบบ')
        }
        finally {
            setIsLoading(false)
        }
    }

    const checkStartDateApply = () => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set the time to midnight

        const startDate = job && new Date(job.startDate)
        if (startDate) {
            startDate.setHours(0, 0, 0, 0);
            if (startDate > currentDate) {
                return false;
            }
        }
        return true;
    };

    const checkAttachFile = async (user) => {
        if (job.documentCode && job.documentCode.length > 0) {
            const userData = JSON.parse(user.data)
            const attList = attachmentList.map(a => a.docType).join(',')
            let validAttachFile = true
            const filteredDocumentCode = job.documentCode.filter(item => item !== 'other'); // ไม่ให้ validate ส่วนของการแนบไฟล์ เมื่อเอกสารประกาศเลือกเอกสารแนบอื่นๆ
            if (userData.rcAttachFile && userData.rcAttachFile.length > 0) {
                filteredDocumentCode.some(item => {
                    if (attList.includes(item) && !userData.rcAttachFile.find(r => r.documentType === item)) {
                        validAttachFile = false
                        return true
                    }
                    return false
                })
            } else {
                validAttachFile = false
            }
            if (!validAttachFile) {
                const propsModal = {
                    type: 'confirm',
                    classModal: 'error',
                    content: `ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจากยังแนบเอกสารไม่ครบ`,
                    okText: "แนบเอกสารเพิ่ม",
                    onOk: async () => {
                        history('/applicantProfile', { state: { jobReq: job } })
                    },
                    onCancel: () => { },
                }
                ModalRc(propsModal)
            }
            return validAttachFile
        }
        return true
    }

    const checkCarLicense = async (user) => {
        if (job) {
            const userData = JSON.parse(user.data)
            let validLicense = true
            let msgErr = ''
            if (job.isMotorcyLicense &&
                (!userData.isMotorcyLicense || (userData.isMotorcyLicense && !userData.motorcyLicenseNo && !userData.isMotorcyLicenseUnderExam))) {
                validLicense = false;
                msgErr = ' รถจักรยานยนต์,'
            }
            if (job.isCarLicense1 &&
                (!userData.isCarLicense1 || (userData.isCarLicense1 && !userData.carLicense1No && !userData.isCarLicense1UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 1,'
            }
            if (job.isCarLicense2 &&
                (!userData.isCarLicense2 || (userData.isCarLicense2 && !userData.carLicense2No && !userData.isCarLicense2UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 2,'
            }
            if (job.isCarLicense3 &&
                (!userData.isCarLicense3 || (userData.isCarLicense3 && !userData.carLicense3No && !userData.isCarLicense3UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 3,'
            }
            if (job.isCarLicense4 &&
                (!userData.isCarLicense4 || (userData.isCarLicense4 && !userData.carLicense4No && !userData.isCarLicense4UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 4,'
            }

            if (!validLicense) {
                msgErr = msgErr.slice(0, msgErr.length - 1)
                const propsModal = {
                    type: 'confirm',
                    classModal: 'error',
                    content:
                        <>
                            <div>{`ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจาก`}</div>
                            <div style={{ maxWidth: '360px' }}>{`ตำแหน่งงานนี้ต้องการทักษะการขับขี่ ${msgErr} `}</div>
                            <div>{`กรุณาระบุให้ครบถ้วน`}</div>
                        </>,
                    okText: "เพิ่มข้อมูล",
                    onOk: async () => {
                        history('/applicantProfile', { state: { jobReq: job } })
                    },
                    onCancel: () => { },
                }
                ModalRc(propsModal)
            } else {
                let proLicenseName = []
                const proLicenseNameAlert = []
                if (job?.professionalLicenseName?.length > 0) {
                    // หาในประกอบวิชาชีพในประกาศที่ตรงกับในใบสมัคร
                    userData.appProfileProLicense.map(e => {
                        const professionalLicenseName = job?.professionalLicenseName.find(val => e.proLicenseName === val)
                        if (professionalLicenseName && !(proLicenseName.filter(el => el.proLicenseName === e.proLicenseName)?.length > 0)) {
                            proLicenseName.push(professionalLicenseName)
                        }
                    })
                    // ตรวจสอบใบประกอบวิชาชีพที่อยู่ในประกาศแต่ไม่มีในใบสมัคร
                    job?.professionalLicenseName.forEach(val1 => {
                        const _proLicenseName = proLicenseName.find(val2 => val1 === val2)
                        if (!_proLicenseName) {
                            proLicenseNameAlert.push(val1)
                        }
                    });
                }
                if (proLicenseNameAlert.length > 0) {
                    validLicense = false
                    msgErr = proLicenseNameAlert.toString()
                    const propsModal = {
                        type: 'confirm',
                        classModal: 'error',
                        content:
                            <>
                                <div>{`ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจาก`}</div>
                                <div style={{ maxWidth: '360px' }}>{`ตำแหน่งนี้บังคับแนบใบประกอบวิชาชีพ ${msgErr}`}</div>
                            </>,
                        okText: "กรอกข้อมูลเพิ่มเติม",
                        onOk: async () => {
                            history('/applicantProfile', { state: { jobReq: job } })
                        },
                        onCancel: () => { },
                    }
                    ModalRc(propsModal)
                }
            }


            return validLicense
        }
        return true
    }

    const checkInvalidData = async (user) => {
        const fieldsCheck = [
            'title',
            'firstName',
            'lastName',
            'gender',
            'nationality',
            'race',
            'religion',
            'birthDate',
            'idCard',
            'maritalStatus',
            'militaryStatus',
            'addressNo',
            'province',
            'district',
            'subDistrict',
            'postCode',
            'phone',
            'email',
        ]
        let validData = true
        const profile = JSON.parse(user.data)
        fieldsCheck.some(fieldName => {
            if (!profile[fieldName]) {
                validData = false
                return true
            }
            return false
        })
        return validData
    }
    const applyJob = async (user) => {
        setIsLoading(true)
        const dateNow = new Date()
        const saveData = {
            status: 'wait',
            documentNo: `RCC-${dateNow.getTime()}`,
            jobRequestNo: job.jobRequestNo,
            jobReqDocumentNo: job.documentNo,
            positionId: job.positionId,
            positionCode: job.positionCode,
            positionName: job.positionName,
            buId: job.buId,
            buCode: job.buCode,
            buName: job.buName,
            positionCareerId: job.positionCareerId,
            positionCareerCode: job.positionCareerCode,
            positionCareerName: job.positionCareerName,
            orgUnitId: job.orgUnitId,
            orgUnitCode: job.orgUnitCode,
            orgUnitName: job.orgUnitName,
            wardCode: job.wardCode,
            wardName: job.wardName,
            divisionCode: job.divisionCode,
            divisionName: job.divisionName,
            positionManageName: job.positionManageName,
            empLevel: job.empLevel,
            manpowerNo: job.manpowerNo,
            email: user?.email?.toLowerCase(),
            applyDate: dateNow,
            createdByName: user.name,
            departmentCode: job.departmentCode,
            departmentName: job.departmentName,
        };
        const result = await axiosRc.post("candidate/create", saveData);
        if (result && result.status === 201) {
            message.success('สมัครสำเร็จ')
            ReactGA.event({
                category: "สมัครงาน",
                action: "สมัครงานสำเร็จ",
                label: `ตำแหน่ง${job?.positionManageName ?? ''} ${job?.positionCareerName ?? ''} ${job?.empLevel ?? ''} ${job?.wardName ?? ''} ${job?.divisionName ?? ''} ${job?.departmentName ?? ''} ${job?.buName ?? ''}`, // optional
                // value: 99, // optional, must be a number
                nonInteraction: true, // optional, true/false
                transport: "xhr", // optional, beacon/xhr/image
            });
            setTimeout(() => {
                history('/myJob')
            }, 500)
        }
        setIsLoading(false)
    }
    const propsContent = {
        handleClickApply,
        job
    }
    return (
        <div className='content-body'>
            {job && <ContentTitle {...propsContent} />}
            {job && <div className="content-body-content flex">
                <ContentLeft {...propsContent} />
                <ContentRight {...propsContent} />
            </div>}
        </div>
    )
}

export default Content